module.exports = __webpack_public_path__ + "static/media/pie-chart.b4126f76.svg";